import { createRequest, RequestConfig } from 'app/common/api';

import { TCredentials } from '../core/sign-in';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/login',
};

export const loginRequest = (body: TCredentials) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
